import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import classes from './Firano.scss';

import Alert from 'cityads-v3/components/Dialog/Alert';
import Table from 'cityads-v3/components/Table/Table';

const cols = [{
  name: 'key',
  title: 'key'
}, {
  name: 'value',
  title: 'value'
}]

type EnumListProps = React.PropsWithChildren<{
  values: Record<string, string>
}>

export default function EnumList({ children, values }: EnumListProps): JSX.Element {
  const { t } = useTranslation(['Finance', 'main'])
  const [open, setOpen] = useState(false);

  return (
    <div>
      <span
        className={classes.enumListLink}
        onClick={() => setOpen(true)}
      >
        {children}
      </span>
      <Alert
        title={t('fieldTable.values')}
        open={open}
        onClose={() => setOpen(false)}
      >
        <Table
          cols={cols}
          rows={Object.keys(values).map(key => ({
            key,
            value: values[key]
          }))}
        />
      </Alert>
    </div>
  );
}
